/* eslint-disable eqeqeq */
import React from "react";
import PropTypes from "prop-types";
import { Row, Col } from "react-flexbox-grid";
import CircularProgress from "@material-ui/core/CircularProgress";
import Button from "@material-ui/core/Button";
import {
  MoreVert as MoreVertIcon,
  LocationOn as LocationOnIcon,
  DescriptionOutlined as DescriptionOutlinedIcon,
  WarningOutlined as WarningOutlinedIcon,
} from "@material-ui/icons";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { formatMoney } from "../Common/decimalHelper";

const getOrigenPedidoLabel = (pedido) => {
  if (pedido.descripcionOrigenPedido || pedido.DescripcionOrigenPedido) {
    return pedido.descripcionOrigenPedido || pedido.DescripcionOrigenPedido;
  }

  const origenPedidoId = pedido.idOrigenPedido ?? pedido.IdOrigenPedido;
  return Number(origenPedidoId) === 2 ? "Whatsapp" : "Ecommerce";
};

class ItemPedido extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      anchorEl: null,
    };
  }

  handleClickMenu = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleCloseMenu = () => {
    this.setState({ anchorEl: null });
  };

  render() {
    const { tipoFacturacion } = this.props.item;
    const requireFacturacion = tipoFacturacion && tipoFacturacion.id === 2;
    const isDelivery =
      Number(this.props.item.idFormaEntrega) === 2 ||
      this.props.item.descripcionFormaEntrega === "DELIVERY";
    const localidadEntrega = isDelivery ? this.props.item.nombreLocalidadEntrega : null;
    const origenPedido = getOrigenPedidoLabel(this.props.item);

    return (
      <Row
        onClick={this.props.item.link}
        className={`itemPedido ${this.props.item.estadoPedido.descripcion.replace(/ /g, "").toLowerCase()}`}
      >
        <Col className="imageContainerPedido">
          {this.props.item.poseeLogo === true && this.props.item.imagen === undefined && (
            <div className="imageLoader">
              <CircularProgress />
            </div>
          )}

          {this.props.item.poseeLogo === true && this.props.item.imagen !== undefined && (
            <img src={this.props.item.imagen} alt="" />
          )}

          {this.props.item.poseeLogo === false &&
            (this.props.item.turno === null || this.props.item.turno === undefined) && (
              <img src={require("../../images/pedidos.png")} alt="Cliente sin logo" />
            )}

          {this.props.item.poseeLogo === false && this.props.item.turno && (
            <img
              src={require(
                `../../images/${this.props.item.turno.idTipoCalendarioCodigoExterno === 1 ? "AvatarPickUp" : "AvatarDelivery"}.png`
              )}
              alt="Cliente sin logo"
            />
          )}

          {this.props.item.turno && (
            <div className="labelTipoEntrega">
              {this.props.item.turno.idTipoCalendarioCodigoExterno === 1 ? "PICK-UP" : "DELIVERY"}
            </div>
          )}
        </Col>

        <Col className="dataContainer">
          <Row className="headerContainer">
            <Col className="header">{`${this.props.item.id} - ${this.props.item.apellidoNombre}`}</Col>
            {this.props.item.faltaGeoreferenciar && (
              <Col className="iconContainer">
                <LocationOnIcon className="icon_red" />
              </Col>
            )}
            {requireFacturacion && (
              <Col className="iconContainer">
                <DescriptionOutlinedIcon className="icon_red" />
              </Col>
            )}
            {this.props.item.fraudePotencial && (
              <Col className="iconContainer">
                <WarningOutlinedIcon className="icon_red"></WarningOutlinedIcon>{" "}
              </Col>
            )}
          </Row>

          <Row bottom="xs">
            <Col className="descriptionContainer">
              <div className="description">
                <div>{`${this.props.item.fechaRegistro} - ${this.props.item.telefono || "sin teléfono"}`}</div>
              </div>
              <div className="description" style={{ margin: "0px" }}>
                {this.props.item.estadoPedido.descripcion}
                {this.props.item.idFormaPagoOnline === 5
                  ? this.props.item.medioPagoOnline
                    ? " - " + this.props.item.medioPagoOnline
                    : " - Pago Online"
                  : this.props.item.descripcionFormaPago
                    ? " - " + this.props.item.descripcionFormaPago
                    : ""}
              </div>
              <div className="description">{`Origen: ${origenPedido}`}</div>
              <div className="description">{`${this.props.item.turno ? (this.props.item.turno.idTipoCalendarioCodigoExterno == 1 ? "Retira -" : "Entrega -") : ""} ${this.props.item.turno ? this.props.item.turno.fechaHora : ""}`}</div>
              <div className="description">
                {localidadEntrega && `Localidad Entrega: ${localidadEntrega}`}
              </div>
            </Col>

            <Col className="containerPrecioMenu">
              <div
                onClick={(e) => {
                  e.stopPropagation();
                }}
                className="menuContainer"
              >
                <Button
                  aria-owns={this.state.anchorEl ? "simple-menu" : undefined}
                  aria-haspopup="true"
                  onClick={this.handleClickMenu}
                >
                  <MoreVertIcon />
                </Button>

                <Menu
                  id="simple-menu"
                  anchorEl={this.state.anchorEl}
                  open={Boolean(this.state.anchorEl)}
                  onClose={this.handleCloseMenu}
                >
                  <MenuItem
                    onClick={() => {
                      this.props.item.caratula();
                      this.handleCloseMenu();
                    }}
                  >
                    Carátula
                  </MenuItem>
                  {this.props.item.estadoPedido &&
                    (this.props.item.estadoPedido.descripcion == "Preparado" ||
                      this.props.item.estadoPedido.descripcion == "Entregado") && (
                      <MenuItem
                        onClick={() => {
                          this.props.item.remito();
                          this.handleCloseMenu();
                        }}
                      >
                        Remito
                      </MenuItem>
                    )}
                  {this.props.item.estadoPedido &&
                    this.props.item.estadoPedido.descripcion == "Confirmado" && (
                      <MenuItem
                        onClick={() => {
                          this.props.item.remito();
                          this.handleCloseMenu();
                        }}
                      >
                        Picking
                      </MenuItem>
                    )}
                  <MenuItem
                    onClick={() => {
                      this.props.item.handleOnClickInfoUsuario(this.props.item);
                      this.handleCloseMenu();
                    }}
                  >
                    Datos usuario
                  </MenuItem>
                </Menu>
              </div>
              <div className="precio">
                {formatMoney(
                  this.props.item.estadoPedido.idEstadoPedido === 3 ||
                    this.props.item.estadoPedido.idEstadoPedido === 4
                    ? this.props.item.totalAPagar
                    : this.props.item.estadoPedido.idEstadoPedido === 2
                      ? this.props.item.totalConfirmado
                      : this.props.item.precioFinal
                )}
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    );
  }
}

ItemPedido.propTypes = {
  item: PropTypes.object.isRequired,
  imagen: PropTypes.array,
};

export default ItemPedido;
